import { createListStore } from './useListStore'

export const useMembersStore = createListStore() 